module.exports = __webpack_public_path__ + "img/avti_7.7d65db66.png";